<template>
  <div class="hero">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="beyond">Elevate Senior Living and Accessibility</h1>
          <!-- Empty div to add spacing -->
          <div class="spacer"></div>
          <p class="hero-description">
            At HeartBeatFam, we're dedicated to enhancing the lives of seniors
            and those with impairments. Our platform is thoughtfully designed to
            cater to their unique needs, offering a streamlined display of apps
            and cutting-edge accessibility features that go far beyond what
            standard tablets can provide.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/assets/_config.json";
export default {
  name: "BeyondTheBook",
  methods: {
    handleGetStarted() {
      this.$router.push("/signup");
    }
  },
  data() {
    return {
      config
    };
  }
};
</script>

<style lang="scss" scoped>
.hero {
  background: url("../../assets/img/home/grandparent-hold-ipad.png") no-repeat
    center center;
  background-size: cover;
  position: relative;
  width: 100vw;
  min-height: 100vh; // Ensures full-screen height
  display: flex;
  align-items: center;
  justify-content: center; // Centers content horizontally and vertically
  color: white;
  padding: 50px 0; // Padding added for top and bottom spacing
}

.beyond {
  font-family: "Lato";
  font-weight: bold;
  font-size: 60px; // Large font for the heading
  line-height: 1.2;
  color: #ffffff;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 20px; // Spacing below heading
  padding-left: 15px;
  padding-right: 15px;
}

.spacer {
  height: 40vh; // This creates a space between the heading and description
}

.hero-description {
  font-family: "Lato";
  font-weight: 200;
  font-size: 20px; // Slightly larger description font
  line-height: 1.6;
  max-width: 600px; // Restrict the width for readability
  color: #ffffff;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 40px;
  padding-left: 15px;
  padding-right: 15px;
}

.btn-signup {
  background: #010610;
  border-radius: 32px;
  height: 50px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  padding: 12px 24px;
  text-transform: uppercase;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border: none;
}

@media (max-width: 768px) {
  .hero {
    min-height: 60vh; // Reduced min-height for smaller screens
    padding: 20px;
  }

  .beyond {
    font-size: 36px;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
  }

  .spacer {
    display: none; // Hides the spacer on mobile view to reduce unnecessary space
  }

  .hero-description {
    font-size: 18px;
    text-align: center;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .btn-signup {
    align-self: center;
    font-size: 14px;
    height: 40px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .hero {
    min-height: 60vh; // Reduced min-height for smaller screens
    padding: 20px;
  }

  .beyond {
    font-size: 36px;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
  }

  .spacer {
    display: none; // Hides the spacer on mobile view to reduce unnecessary space
  }

  .hero-description {
    font-size: 18px;
    text-align: center;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .btn-signup {
    align-self: center;
    font-size: 14px;
    height: 40px;
  }
}
</style>
